import { Injectable } from "@angular/core";

/**
 * Data Access Object for whether the floating chat button should be shown.
 */
@Injectable({
  providedIn: "root",
})
export class ChatFabEnabledDao {
  private readonly CHAT_FAB_ENABLED_KEY = "chat-fab-enabled";

  setChatFabEnabled(enabled: boolean): void {
    window.localStorage.setItem(
      this.CHAT_FAB_ENABLED_KEY,
      JSON.stringify(enabled)
    );
  }

  /**
   * Defaults to true when the user has not chosen a preference yet.
   */
  getChatFabEnabled(): boolean {
    const value = window.localStorage.getItem(this.CHAT_FAB_ENABLED_KEY);
    return value === null ? true : JSON.parse(value);
  }
}
